<template>
  <section v-if="fields?.content?.value" :class="rootClass" :style="rootStyle">
    <ContentGrid :desktop-default-grid="[2, 20]" :mobile-default-grid="[1, 14]">
      <ElementSiteRichText :field="fields.content" class="c-site-rich-text__content" />
    </ContentGrid>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ElementSiteRichText from '@/elements/SiteRichText.vue';
import utils from '@/utils';
import type { SiteRichTextProps } from '@/types/components/SiteRichText';

const props = defineProps<SiteRichTextProps>();
const fields = computed(() => props.fields);

const rootClass = computed(() => utils.overall.baseComClass(props.fields, 'c-site-rich-text'));
const rootStyle = computed(() => utils.overall?.baseComStyle?.(fields.value) || {});
</script>

<style lang="scss">
@import '../../styles/variables';
@import '../../styles/functions';
@import '../../styles/mixins';
</style>
